import React, { useState, useEffect } from "react";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../HandleAPICalls/actions";
import ComboListComponent from "./component";

const ComboListContainer = (props) => {
  const [combos, setCombos] = useState([]);
  const [filteredCombos, setFilteredCombos] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [comboStatusFilter, setComboStatusFilter] = useState([]);
  const [sortOption, setSortOption] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCombos();
  }, []);

  const fetchCombos = () => {
    setLoading(true);
    props.getDataFromAPI(
      `/partner/api/v2/combo/all`,
      "GET",
      undefined,
      (response) => {
        const normalizedData = response.map((combo) => ({
          ...combo,
          isActive: !!combo.isActive,
        }));
        setCombos(normalizedData);
        setFilteredCombos(normalizedData);
        setLoading(false);
      },
      (err) => {
        console.log("API Error:", err);
        toastr.error("Error", err?.message || "Failed to fetch combos");
        setLoading(false);
      }
    );
  };

  const SearchCombosApi = (query) => {
    const normalizedQuery = String(query || "").trim();

    if (!normalizedQuery) {
      // If search is empty, apply filters and sorting to original data
      applyFiltersAndSort(combos);
      return;
    }

    // Show loading only for API call
    // Use local filtering instead of API call for better performance
    const searchLower = normalizedQuery.toLowerCase();
    const filtered = combos.filter((combo) => {
      const nameMatch = combo.name?.toLowerCase().includes(searchLower) || false;
      const idMatch = combo.id?.toString().includes(normalizedQuery) || false;
      return nameMatch || idMatch;
    });

    applyFiltersAndSort(filtered);
  };

  const applyFiltersAndSort = (data) => {
    let filtered = [...data];

    // Apply status filter
    if (comboStatusFilter.length > 0) {
      filtered = filtered.filter((combo) => {
        const comboStatus = combo.isActive ? "Active" : "Inactive";
        return comboStatusFilter.includes(comboStatus);
      });
    }

    // Apply sort
    if (sortOption === "aToZ") {
      filtered = filtered.sort((a, b) => a.name?.localeCompare(b.name) || 0);
    } else if (sortOption === "zToA") {
      filtered = filtered.sort((a, b) => b.name?.localeCompare(a.name) || 0);
    } else if (sortOption === "priceLowToHigh") {
      filtered = filtered.sort((a, b) => (a.total_price || 0) - (b.total_price || 0));
    } else if (sortOption === "priceHighToLow") {
      filtered = filtered.sort((a, b) => (b.total_price || 0) - (a.total_price || 0));
    }

    setFilteredCombos(filtered);
  };

  const toggleComboStatusFilter = (status) => {
    setComboStatusFilter((prevFilter) =>
      prevFilter.includes(status)
        ? prevFilter.filter((item) => item !== status)
        : [...prevFilter, status]
    );
  };

  // Apply filters and sorting whenever dependencies change
  useEffect(() => {
    // Start with all combos
    let filtered = [...combos];

    // Apply search filter locally
    if (searchTerm.trim()) {
      const searchLower = searchTerm.toLowerCase();
      filtered = filtered.filter((combo) => {
        const nameMatch = combo.name?.toLowerCase().includes(searchLower) || false;
        const idMatch = combo.id?.toString().includes(searchTerm) || false;
        return nameMatch || idMatch;
      });
    }

    // Apply status filter
    if (comboStatusFilter.length > 0) {
      filtered = filtered.filter((combo) => {
        const comboStatus = combo.isActive ? "Active" : "Inactive";
        return comboStatusFilter.includes(comboStatus);
      });
    }

    // Apply sort
    if (sortOption === "aToZ") {
      filtered = filtered.sort((a, b) => a.name?.localeCompare(b.name) || 0);
    } else if (sortOption === "zToA") {
      filtered = filtered.sort((a, b) => b.name?.localeCompare(a.name) || 0);
    } else if (sortOption === "priceLowToHigh") {
      filtered = filtered.sort((a, b) => (a.total_price || 0) - (b.total_price || 0));
    } else if (sortOption === "priceHighToLow") {
      filtered = filtered.sort((a, b) => (b.total_price || 0) - (a.total_price || 0));
    }

    setFilteredCombos(filtered);
  }, [combos, searchTerm, comboStatusFilter, sortOption]);

  const handleClearAllFilter = () => {
    setSearchTerm("");
    setComboStatusFilter([]);
    setSortOption("");
    setFilteredCombos(combos);
  };

  return (
    <ComboListComponent
      loading={loading}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      comboStatusFilter={comboStatusFilter}
      setComboStatusFilter={setComboStatusFilter}
      combos={filteredCombos}
      sortOption={sortOption}
      setSortOption={setSortOption}
      toggleComboStatusFilter={toggleComboStatusFilter}
      handleClearAllFilter={handleClearAllFilter}
      SearchCombosApi={SearchCombosApi}
    />
  );
};

function mapStateToProps(state) {
  return {
    // Add redux state here if needed
  };
}

export default connect(mapStateToProps, {
  getDataFromAPI,
})(ComboListContainer);